import { Container } from "@material-ui/core";
import React from "react";
import { TextBox, TextBoxProps } from "../../atoms/Text Box/TextBox";
import { FourTextWrapper } from "./OurServicesStyles";
import { FourTextPapers } from "../../molecules/FourTextPapers/FourTextPapers";
import * as strings from "../../utilities/strings";
import { textBoxes } from "../landingpage/LandingPageConstants";

export interface OurServicesPageProps {
  textBoxes: Array<TextBoxProps>;
}

export const OurServicesPage: React.FC<OurServicesPageProps> = (
  props: OurServicesPageProps
) => {

  return (
    <Container>
      <TextBox
        title={""}
        paragraphs={[strings.serviceText]}
        image={""}
        titleColor={"#403F3F"}
        bodyFontSize={18}
        headerFontSize={40}
      />
      <FourTextWrapper>
        <FourTextPapers textBoxes={textBoxes} />
      </FourTextWrapper>
    </Container>
  );
};
